import React, { useContext, useEffect, useRef } from 'react'
import styles from "../css/DeleteNote.module.css"
import { IoClose } from "react-icons/io5";
import Loader from '../../Loaders/js/Loader';
import { PageContext } from '../../board/js/Notes';
import LoadingButton from '../../Loaders/js/LoadingButton';
import NotFound from '../../Error/js/NotFound';
import CrashError from '../../Error/js/CrashError';
import { useDispatch, useSelector } from 'react-redux';
import { deleteNote, viewNote } from '../../../actions/noteActions';
import { FiTrash2, FiX } from 'react-icons/fi';

const DeleteNote = () => {
    const [pageModals,setPageModals] = useContext(PageContext)
    const { delete: id} = pageModals
    const fetching = useRef(true)
    const loading = useSelector((state)=> state.noteState.loading)
    const note = useSelector((state)=>state.noteState.selectedNote)
    const crashError = useSelector((state)=>state.noteState.crashError)
    const notFoundError = useSelector((state)=>state.noteState.notFound)
    const dispatch = useDispatch()

    useEffect(()=>{
        if (fetching.current){
            fetching.current = false
            dispatch(viewNote(id))
        }
    },[id,dispatch])


    const closeModal = () => {
        setPageModals((prevState)=>{
            let copy = {...prevState}
            copy.delete = null
            return copy
        })
    }

    const handleDelete = async () => {
        try{
            await dispatch(deleteNote(id))
            closeModal()
        }
        catch(err){}
    }

    return (
        notFoundError.state ?
            <NotFound
                msg = {notFoundError.text}
                closeMenu = {()=>setPageModals({...pageModals,delete:null})}
            /> 
            : 
        crashError.state ?
            <CrashError
                msg = {crashError.text}
                retry = {()=> (note ? handleDelete() : dispatch(viewNote(id)))}
                closeMenu = {()=>setPageModals({...pageModals,delete:null})}
            /> 
            :
        <div className = {styles.wrapper}>
            {note ? 
                <div data-testid = {`delete-modal-${id}`} className={styles.modal} style={{ position: "relative" }}>
                    <button data-testid = "close-btn" className={styles.close} onClick = {()=>setPageModals({...pageModals,delete:null})}>
                        <FiX/>
                    </button>

                    <div className={styles.body}>
                        <div className={styles.iconWrap}>
                            <div className={styles.icon}><FiTrash2/></div>
                        </div>
                        <div className={styles.title}>Delete this note?</div>
                        <div className={styles.desc}>
                            This action cannot be undone. This will permanently delete the note named <strong>{note.title}</strong>.
                        </div>
                    </div>

                    <div className={styles.footer}>
                        <button data-testid = "note-delete-btn" type = "button" className={`${styles.btn} ${styles.confirm} ${loading ? styles.loading : ""}`} onClick = {()=>handleDelete()}>
                            <FiTrash2/> Delete Note
                            {loading && <LoadingButton deleting = {true}/>}
                        </button>
                        <button data-testid = "cancel-btn" type = "button" className={`${styles.btn} ${styles.cancel}`} onClick = {()=>closeModal()}>Cancel</button>
                    </div>
                </div> : 
                <div className = {styles.modal}>
                    <div className = {styles.header}>
                        <div className = {styles.title}>Delete Note</div>
                        <div className = {styles.closeBtn} onClick = {()=>closeModal()}><IoClose/></div>
                    </div>
                    <div className = {styles.loadingArea}><Loader/></div>
                </div>}
        </div>
    )
}

export default DeleteNote